module.exports = __webpack_public_path__ + "static/media/smilepass-logo.2d8109a2.svg";